enum TransactionResult {
  ApprovedOnline = 1,
  ApprovedOffline = 2,
  ApprovedManual = 3,
  DeclinedOnline = 4,
  DeclinedOffline = 5,
  Cancelled = 9,
  TransactionPerformed = 10,
  CaptureCardDeclineOnline = 16,
  TerminalRecovery = 17,
  TransactionAborted = 19,
  PreSalesCompleted = 20,
  PreSalesRejected = 21,
  CardNumberNotMatched = 22,
  ExpiryDateNotMatched = 23,
  InvalidTransactionState = 24,
  NotValidForRequestedOperation = 25,
  InvalidPGTR = 26,
  InvalidMerchant = 27,
  InvalidTerminal = 28,
  MerchantStatusNotValid = 29,
  InvalidCardNumber = 30,
  ExpiredCard = 31,
  PreValidCard = 32,
  InvalidIssueNumber = 33,
  InvalidCardExpiryDate = 34,
  InvalidStartDate = 35,
  CardNotAccepted = 36,
  TransactionNotAllowed = 37,
  CashBackNotAllowed = 38,
  StatusBusy = 42,
  StatusNotBusy = 43,
  PinpadNotConnected = 44,
  PinpadConnected = 45,
  AVSDetailsRequired = 50,
  DeclineOnlineUnverified = 4001
}

export default TransactionResult;
